<template lang="pug">
  #StoresManagerIndex
    //- h5.text-center.pt-2 店鋪管理
    b-row(
      no-gutters
      class="m-3 px-2"
    )
      .tabContainer.d-flex.justify-content-center.w-100
        .tab(
          block,
          :class="{'selected': nowSelectType === 'index-sa'}",
          @click="changeTypeHandler('index-sa')"
        ) 顧問
        .tab.mt-0.mx-3(
          block,
          :class="{'selected': nowSelectType === 'index-customer'}",
          @click="changeTypeHandler('index-customer')"
        ) 顧客
        .tab.mt-0(
          block,
          class="button-last rounded-0",
          :class="{'selected': nowSelectType === 'index-reservation'}",
          @click="changeTypeHandler('index-reservation')"
        ) 預約
    //.row.align-items-center.no-gutters.mx-3.my-2(v-if="nowSelectType === 'index-customer'")
      i.fa.fa-users.mr-2
      span {{ storeData.member_count }} 位
    .px-3
      .reservationInfo.mr-2(
        v-show="nowSelectType === 'index-reservation'"
      )
        multiselect.multiselect__dark.w-100.mb-2(
          v-model="selectedStatus",
          placeholder="請選擇預約狀態",
          selectedLabel="已選擇",
          selectLabel="點擊選擇預約狀態",
          :options="statusList",
          :allow-empty="false"
          noOptions="無預約狀態"
          label="name"
          @input="changeStatusHandler"
        )
          template(slot="noOptions")
            strong 無預約狀態
        //.my-2
          i.fa.fa-users.mr-2
          span {{ storeData[0].member_count }} 筆
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(store,index) in storeData",
        :key="index",
        v-if="storeData && storeData.length > 0"
      )
        //- 店鋪BA
        .typeOneShow(
          v-if="nowSelectType === 'index-sa'"
        )
          .row.align-items-center.no-gutters
            .col-3.pr-1
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="store.picture_url",
                :style="{ 'width': '60px', 'height': '60px' }"
              )
            .col-9.px-3(style='height: 60px; display: flex; flex-direction: column; justify-content: space-evenly;')
              small.d-block.mb-0 姓名： {{ `${store.chinese_last_name} ${store.chinese_first_name}` }}
              small.d-block.mb-0 綁定數： {{ filterMoney(store.member_count) }}
        //- 店鋪顧客
        .typeTwoShow(
          v-if="nowSelectType === 'index-customer'"
        )
          .row.align-items-center.no-gutters
            .col-3.pr-1
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="store.picture_url",
                :style="{ 'width': '60px', 'height': '60px' }"
              )
            .col-9.px-3
              small.d-block.mb-0 姓名： {{ store.customer_chinese_first_name }}
              small.d-block.mb-0 暱稱名： {{ store.display_name }}
              small.d-block.mb-0 綁定時間： {{ moment(store.bind_at).format('YYYY/MM/DD') }}
              small.d-block.mb-0(v-if="!store.bindStore") 顧問： {{ store.sa_preferred_name }}
          .fakePadding_h-30(v-if="store.bindStore")
          .row.align-items-center.no-gutters.d-flex.customerBindStyle.w-100.p-2.position-absolute(v-if="store.bindStore")
            small
              i.fas.fa-map-marker-alt.mr-2
              span {{ store.bindStore }}
            small
              i.fa.fa-user.mr-2
              span 顧問： {{ store.sa_preferred_name }}

        .typeThreeShow(
          v-if="nowSelectType === 'index-reservation'"
        )
          .row.align-items-center.no-gutters
            .col-3.pr-1
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="store.picture_url",
                :style="{ 'width': '60px', 'height': '60px' }"
              )
            .col-9.px-3(style='height: 60px; display: flex; flex-direction: column; justify-content: space-evenly;')
              small.d-block.mb-0 姓名： {{ store.customer_chinese_first_name }}
              small.d-block.mb-0 暱稱名： {{ store.line_name }}
          .reserveAtRow.mb-2.d-flex.align-items-center.mt-3
            i.far.fa-calendar-check.mr-2
            small 預約時間：{{ moment(store.reserve_start_at).format('YYYY/MM/DD') }} {{ moment(store.reserve_start_at).format('HH:mm') }}
          .typeRow.mb-2.d-flex.align-items-center
            i.fas.fa-border-all.mr-2
            small 服務內容：{{ store.reserve_type_name }}
          .statusRow.mb-2.d-flex.align-items-center
            i.far.fa-check-circle.mr-2
            small 預約狀態：{{ store.status === 'checked' ? '完成預約' : store.status === 'checking' ? '確認中' : store.status === 'success' ? '到店諮詢' : store.status === 'expired' ? '已過期' : '-' }}
          .statusRow.mb-2.d-flex.align-items-center(v-if="!store.bindStore")
            i.fa.fa-user.mr-2
            small.d-block.mb-0 顧問： {{ store.sa_chinese_last_name }}{{ store.sa_chinese_first_name}}
          .fakePadding_h-15(v-if="store.bindStore")
          .row.align-items-center.no-gutters.d-flex.customerBindStyle.w-100.p-2.position-absolute(v-if="store.bindStore")
            small
              i.fas.fa-map-marker-alt.mr-2
              span {{ store.bindStore }}
            small
              i.fa.fa-user.mr-2
              span 顧問： {{ store.sa_chinese_last_name }}{{ store.sa_chinese_first_name}}
        //- .labelTag(
        //-   v-if="store.status === 'expired'",
        //-   style="right: 0;bottom: 0;"
        //- )
        //-   span.labelTag__text 已過期
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SM_STORES_MANAGER_EDIT_SA } from '@/router/sm/stores-manager';
const moment = require('moment');

export default {
  name: 'StoresManagerIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      nowSelectType: 'index-sa',
      nowSelectStatus: 'checking',
      infiniteId: +new Date(),
      storesSelect: {
        dealer: null,
        store: null
      },
      statusList: [
        {
          id: 'checking',
          name: '確認中'
        },
        {
          id: 'checked',
          name: '預約完成'
        },
        {
          id: 'success',
          name: '到店諮詢'
        },
        {
          id: 'expired',
          name: '已過期'
        }
      ],
      selectedStatus: { status: 'checking', name: '確認中' }
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.dispatch('sm_profile/getProfileHandler')
      .then(() => {
        vm.$swal.close();
      });
    vm.$store.commit('sm_stores_manager/resetHandler');
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('sm_stores_manager/getStoreDealerHandler')
      .then(() => {
        if (vm.storeDealer && vm.storeDealer.length > 0) {
          vm.storesSelect.dealer = vm.storeDealer[0];
          setTimeout(() => {
            vm.$store.dispatch('sm_stores_manager/getStoresHandler', {
              store_dealer_id: vm.storeDealer[0].id
            }).then(() => {
              if (vm.stores && vm.stores.length > 0) {
                vm.storesSelect.store = vm.smProfileData.stores[0];
                vm.infiniteId += 1;
              }
              vm.$swal.close();
            });
          }, 50);
        } else {
          vm.$swal.close();
        }
      });
  },
  methods: {
    moment() {
      return moment();
    },
    infiniteHandler($state) {
      const vm = this;
      let targetApi;
      switch (vm.nowSelectType) {
        case 'index-sa':
          targetApi = 'getIndexSaHandler';
          break;
        case 'index-customer':
          targetApi = 'getIndexCustomerHandler';
          break;
        case 'index-reservation':
          targetApi = 'getIndexReservationHandler';
          break;
        default:
          break;
      }
      if (!vm.storesSelect.store || !targetApi) return;
      vm.$store.dispatch(`sm_stores_manager/${targetApi}`, {
        current_page: parseInt(vm.pagination.current_page) + 1,
        per_page: parseInt(vm.pagination.per_page),
        store_id: vm.storesSelect.store.id,
        status: vm.nowSelectStatus
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeTypeHandler(type) {
      const vm = this;
      switch (type) {
        case 'index-sa':
          if (vm.nowSelectType === 'index-sa') return;
          vm.nowSelectType = 'index-sa';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'index-customer':
          if (vm.nowSelectType === 'index-customer') return;
          vm.nowSelectType = 'index-customer';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'index-reservation':
          if (vm.nowSelectType === 'index-reservation') return;
          vm.nowSelectType = 'index-reservation';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    changeStatusHandler(val) {
      const vm = this;
      switch (val.id) {
        case 'checked':
          if (vm.nowSelectStatus === 'checked') return;
          vm.nowSelectStatus = 'checked';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checking':
          if (vm.nowSelectStatus === 'checking') return;
          vm.nowSelectStatus = 'checking';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelectStatus === 'success') return;
          vm.nowSelectStatus = 'success';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'expired':
          if (vm.nowSelectStatus === 'expired') return;
          vm.nowSelectStatus = 'expired';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    editSaHandler(sa_info) {
      const vm = this;
      vm.$router.push({
        name: SM_STORES_MANAGER_EDIT_SA,
        params: {
          sa_info,
          store_id: vm.storesSelect.store.id
        }
      });
    },
    // 更換經銷商
    selectDealerHandler(selectedOption) {
      const vm = this;
      if (!selectedOption) return;
      vm.$store.commit('sm_stores_manager/resetHandler');
      vm.storesSelect.store = null;

      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });

      vm.$store.dispatch('sm_stores_manager/getStoresHandler', {
        store_dealer_id: selectedOption.id
      }).then(() => {
        if (vm.stores && vm.stores.length > 0) {
          vm.storesSelect.store = vm.stores[0];
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
        }
        vm.$swal.close();
      });
    },
    // 更換店家
    selectStoreHandler(selectedOption) {
      const vm = this;
      if (!selectedOption) return;
      vm.$store.commit('sm_stores_manager/resetHandler');
      vm.infiniteId += 1;
    }
  },
  computed: {
    ...mapState({
      storeData: (state) => state.sm_stores_manager.storeData,
      storeDealer: (state) => state.sm_stores_manager.storeDealer,
      stores: (state) => state.sm_stores_manager.stores,
      storeInfo: (state) => state.sm_stores_manager.storeInfo,
      pagination: (state) => state.sm_stores_manager.pagination,
      smProfileData: (state) => state.sm_profile.data
    })
  }
};
</script>

<style lang="scss" scoped>
.multiselect__placeholder {
  margin-bottom: 8px;
}

.tab {
  border-right: none;
  width: 20%;
}

.customerBindStyle {
  background: #b2a392;
  color: #fff;
  left: 0;
  bottom: 0;
  justify-content: space-around;
}
</style>
